export default "__VITE_ASSET__15905679__"